import { Controller } from "@hotwired/stimulus"

// Live preview + custom-field toggle for the custom report date format selector.
// Renders today's date in the selected format using localized day/month names
// supplied as values, mirroring the server-side CustomReports::DateFormatter.
//
// Usage:
//   <div data-controller="date-format"
//        data-date-format-day-names-value="[...]"
//        data-date-format-abbr-day-names-value="[...]"
//        data-date-format-month-names-value="[...]"
//        data-date-format-abbr-month-names-value="[...]">
//     <select data-date-format-target="preset" data-action="change->date-format#refresh">
//     <input  data-date-format-target="custom" data-action="input->date-format#refresh">
//     <div    data-date-format-target="customWrapper">
//     <span   data-date-format-target="preview">
//   </div>
export default class extends Controller {
  static targets = ["preset", "custom", "customWrapper", "preview"]
  static values = {
    dayNames: Array,
    abbrDayNames: Array,
    monthNames: Array,
    abbrMonthNames: Array,
  }

  connect() {
    this.refresh()
  }

  refresh() {
    const preset = this.presetTarget.value
    const isCustom = preset === "custom"

    if (this.hasCustomWrapperTarget) {
      this.customWrapperTarget.classList.toggle("hidden", !isCustom)
    }

    const strftime = isCustom ? this.customValue() : this.strftimeForOption()
    this.previewTarget.textContent = strftime ? this.format(new Date(), strftime) : "–"
  }

  customValue() {
    return this.hasCustomTarget ? this.customTarget.value.trim() : ""
  }

  strftimeForOption() {
    const option = this.presetTarget.selectedOptions[0]
    return option ? option.dataset.strftime || "" : ""
  }

  // Minimal strftime supporting the tokens used by the presets/custom formats.
  format(date, pattern) {
    const pad = (n) => String(n).padStart(2, "0")
    // Rails day_names/month_names are Sunday- and January-first arrays.
    const tokens = {
      "%A": this.dayNamesValue[date.getDay()],
      "%a": this.abbrDayNamesValue[date.getDay()],
      "%B": this.monthNamesValue[date.getMonth() + 1],
      "%b": this.abbrMonthNamesValue[date.getMonth() + 1],
      "%d": pad(date.getDate()),
      "%-d": String(date.getDate()),
      "%e": String(date.getDate()).padStart(2, " "),
      "%m": pad(date.getMonth() + 1),
      "%-m": String(date.getMonth() + 1),
      "%Y": String(date.getFullYear()),
      "%y": pad(date.getFullYear() % 100),
    }

    return pattern.replace(/%-d|%-m|%[AaBbdemYy]/g, (match) =>
      match in tokens ? tokens[match] : match,
    )
  }
}
